import { AdminOptionableFilter } from "../AdministrateEnumFilter";

export const PayorOptionsFilter = ({ queryParams, pageSize = 100, ...rest }) => {
  return (
    <AdminOptionableFilter
      resource="payors"
      queryParams={{ payor: { order: "name", direction: "asc", per_page: pageSize }, ...queryParams }}
      searchParam="name"
      kept
      {...rest}
    />
  );
};
